var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":_vm.viewBox}},[_c('polygon',{attrs:{"fill":_vm.fillColor,"stroke":"none","points":_vm.areaPoints}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"none","stroke":_vm.strokeColor,"stroke-width":"4","points":_vm.linePoints}})])
}
var staticRenderFns = []

export { render, staticRenderFns }